import script from "./LeaveAdminSectionNav.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveAdminSectionNav.vue?vue&type=script&setup=true&lang=js"

import "./LeaveAdminSectionNav.vue?vue&type=style&index=0&id=2a11e2a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a11e2a8"]])

export default __exports__